import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { mapTo, tap } from 'rxjs/operators';
import { ApiService } from '../../../shared/services/core/api.service';
import { lowerCaseKeys } from '../../../shared/services/core/lowercasekeys.service';
import { PopUpNotificationDto } from './models/popup-notification-dto.model';
import { PopUpNotificationResponseType } from './models/popup-notification-response-type';
import { PopUpNotificationStore } from './popup-notification.store';

@Injectable({ providedIn: 'root' })
export class PopUpNotificationService {
  constructor(private store: PopUpNotificationStore, private api: ApiService) {}

  /**
   * Retrieve the current customer's avalaible popup notifications and populate the store
   */
  fetchPopUpNotifications() {
    const request$ = this.api.get<PopUpNotificationDto>('notificationspopup/unseenpopup').pipe(
      tap((popUpNotifications) => {
        this.store.set(lowerCaseKeys(popUpNotifications));
      })
    );

    return cacheable(this.store, request$, { emitNext: true }).pipe(mapTo(null));
  }

  /**
   * Mark a given notification as read and remove it from the store
   * @param popUpNotificationId The popup notification to mark as read
   * @param responseType The user's response type to the popup
   * @param seenDate the date/time when the popup was seen/responded to
   */
  markNotificationsAsRead(popUpNotificationId: number, responseType: PopUpNotificationResponseType) {
    return this.api
      .post('notificationspopup/respondtopopup', { popUpNotificationId, responseType })
      .pipe(
        tap(() => {
          this.store.remove(popUpNotificationId);
        }),
        mapTo(null)
      )
      .toPromise();
  }
}
